import React from 'react';
import './CollapsedFundList.scss';
import { isCollegeAnything } from 'src/utils/transactions-util';
import { currency } from 'src/utils/utils';
import classNames from 'classnames';

export interface CollapsedFundListProps {
  clickable: boolean;
  isRecurring?: boolean;
  onEditClick;
  shoppingCartLength: number;
  shoppingCartTotal;
}

const CollapsedFundList: React.FC<CollapsedFundListProps> = ({
  clickable,
  isRecurring,
  onEditClick,
  shoppingCartLength,
  shoppingCartTotal,
}) => (
  <div
    className={classNames(
      'collapsed-fund-list-header',
      'e2e-collapsed-fundlist',
      {
        'collapsed-fund-list-pointer': clickable,
        'collapsed-fund-list-non-pointer': !clickable,
      }
    )}
    onClick={clickable ? onEditClick : undefined}
  >
    {currency(shoppingCartTotal)} added to {shoppingCartLength}
    {isRecurring
      ? shoppingCartLength > 1
        ? ' investments'
        : ' investment'
      : isCollegeAnything()
      ? shoppingCartLength > 1
        ? ' portfolios'
        : ' portfolio'
      : shoppingCartLength > 1
      ? ' funds'
      : ' fund'}
    {isRecurring && <span> on a custom frequency</span>}
    <a
      className="college-branded-link collapsed-fund-list-edit-link"
      id="funds-list-edit-link"
    >
      Edit
    </a>
  </div>
);

export default CollapsedFundList;
